import { ReactElement } from 'react'
import { Button, Text } from '../atoms'
import { useKeyboardControls } from '../../contexts/KeyboardControlsContext'
import { ControlHighlight, KeyboardControl } from '../molecules/KeyboardControls'
import { HighlightEffect } from '../../enums/KeyboardControls'

export const NALOXONE_COMPLETION_MESSAGE_LINE_1 =
  'Thank you for requesting Naloxone to keep your community safe, happy, and healthy!'

export const NALOXONE_COMPLETION_MESSAGE_LINE_2 =
  'Your answers have been recorded anonymously and will be used for research purposes to improve access to overdose prevention methods for other students. DopaGE certifies that no personally identifiable information has been recorded in connection with your participation in this survey.'

const kbControlsLayer = 'survey'
const buttonId = 'naloxone-completion-continue-button'

interface NaloxoneCompletionProps {
  // Only on the authenticated path - the public QR path has nowhere to go.
  onContinue?: () => void
}

export const NaloxoneCompletion = ({ onContinue }: NaloxoneCompletionProps): ReactElement => {
  const keyboardControls = useKeyboardControls()

  return (
    <div className='flex flex-col h-full items-center justify-center text-center' role='region' aria-labelledby='naloxone-completion-heading'>
      <h2 className='sr-only' id='naloxone-completion-heading'>Naloxone Survey Complete</h2>
      <Text
        text={NALOXONE_COMPLETION_MESSAGE_LINE_1}
        size='LG'
        className='text-dopage-lightGreen mb-6'
      />
      <Text
        text={NALOXONE_COMPLETION_MESSAGE_LINE_2}
        size='SM'
        className='text-dopage-lightGreen'
      />
      {onContinue != null && (
        <div className='flex justify-center mt-8'>
          <ControlHighlight
            active={keyboardControls.isEnabled && keyboardControls.isElementFocused(buttonId)}
            highlightEffect={HighlightEffect.ButtonHexOutline}
          >
            <KeyboardControl layer={kbControlsLayer}>
              <Button
                id={buttonId}
                onClick={onContinue}
                className='px-8 py-3 font-semibold'
              >
                <span>Continue</span>
              </Button>
            </KeyboardControl>
          </ControlHighlight>
        </div>
      )}
    </div>
  )
}

export default NaloxoneCompletion
